import { debugJingtaiV2FnRawCodes } from './debugJingtaiV2'
import { createRoyuanFnRawCodePreview, debugRoyuanFnRawCodes } from './debugRoyuanFn'

const debug = async () => {
  //debugNa87()
  // setKeys()
  //console.clear()
  //debugMU68()
}

export const setDebug = () => {
  ;(window as any).debug = debug
}
